"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.giftStatusColor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _constants = require("../constants");

var giftStatusIcons = {
  'Invite delivered': 'envelope',
  'Invite in transit': 'shipping-fast',
  'Invite resent': 'shipping-fast',
  'Follow up sent': 'bell',
  'Invite scheduled': 'clock',
  'Invite viewed': 'eye',
  'Gift accepted': 'thumbs-up',
  'Options ready': 'lightbulb-on',
  'Invite processing': 'cog',
  'Invite bounced': 'level-up',
  'Gift created': 'flask',
  'Invite expired': 'exclamation-circle',
  'Gift declined': 'thumbs-down',
  'Meeting booked': 'calendar-alt',
  'Meeting times available': 'calendar-alt',
  'Invite disabled': 'ban',
  'Invite returned': 'arrow-left'
};
var giftStatusColor = {
  'Invite disabled': 'error',
  'Invite delivered': 'grey',
  'Invite scheduled': 'grey',
  'Invite in transit': 'grey',
  'Invite resent': 'grey',
  'Follow up sent': 'grey',
  'Invite viewed': 'grey',
  'Gift accepted': 'grey',
  'Options ready': 'grey',
  'Invite processing': 'grey',
  'Gift created': 'grey',
  'Meeting booked': 'grey',
  'Invite bounced': 'error',
  'Invite expired': 'error',
  'Gift declined': 'error',
  'Invite returned': 'error'
};
exports.giftStatusColor = giftStatusColor;
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      position: 'relative',
      padding: spacing(2),
      paddingLeft: spacing(4),
      margin: spacing(2),
      marginLeft: spacing(4)
    },
    icon: {
      width: 'auto',
      fontSize: spacing(2)
    },
    date: {
      fontSize: '12px'
    },
    avatar: {
      background: palette.background.default,
      width: '44px',
      height: '44px',
      position: 'absolute',
      left: '-22px',
      border: "2px solid ".concat(palette.common.white),
      top: '7px'
    },
    rootPrimary: {
      border: "2px solid ".concat(palette.primary.main)
    },
    avatarPrimary: {
      background: '#eaecf1'
    },
    dots: {
      position: 'absolute',
      height: 40,
      left: 10,
      zIndex: -1,
      border: "2px dotted ".concat(palette.divider)
    }
  };
});

var GiftHistoryStatus = function GiftHistoryStatus(_ref2) {
  var date = _ref2.date,
      title = _ref2.title,
      description = _ref2.description,
      primary = _ref2.primary,
      useDots = _ref2.useDots,
      isOneOffGift = _ref2.isOneOffGift;
  var classes = useStyles();
  var iconColor = (0, _react.useMemo)(function () {
    if (primary && giftStatusColor[title] !== 'error') {
      return 'primary';
    }

    return giftStatusColor[title];
  }, [title, primary]);
  var localDate = (0, _react.useMemo)(function () {
    return (0, _moment.default)(date).local().format(_constants.USER_FULL_NUMBER_DATE_FORMAT);
  }, [date]);
  return /*#__PURE__*/_react.default.createElement(_material.Paper, {
    className: (0, _classnames.default)(classes.root, primary && classes.rootPrimary),
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: (0, _classnames.default)(classes.avatar, primary && classes.avatarPrimary)
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: giftStatusIcons[title],
    color: iconColor,
    className: classes.icon
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "baseline"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.title,
    variant: "h4"
  }, title), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.date
  }, localDate)), !isOneOffGift && description), useDots && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dots
  }));
};

GiftHistoryStatus.propTypes = {
  date: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  primary: _propTypes.default.bool,
  description: _propTypes.default.node,
  useDots: _propTypes.default.bool,
  isOneOffGift: _propTypes.default.bool
};
GiftHistoryStatus.defaultProps = {
  primary: false,
  description: '',
  useDots: true,
  isOneOffGift: false
};
var _default = GiftHistoryStatus;
exports.default = _default;